import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=21377004&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21377004')) {
      api.createRecord('21377004', component.options)
    } else {
      api.reload('21377004', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=21377004&", function () {
      api.rerender('21377004', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22M0Ip99fHjKm/JS/comp/ErrorMessage.vue"
export default component.exports